import { useEffect, useState } from 'react';
import { Select, Button, Modal } from 'antd';
import api from '../utils/apiClient';
import UserForm from './UserForm';

const TenantAdminSelector = ({ value, tenantId, onChange }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);

  useEffect(() => {
    setLoading(true);
    if (tenantId) {
        api.get(`/tenants/${tenantId}/users`)
        .then(({ data }) => setUsers(data))
        .catch((e) => console.error(e))
        .finally(() => setLoading(false));
    } else {
        setUsers([]);
        setLoading(false);
    }
  }, [tenantId]);

  const handleUserCreated = (user) => {
    setUsers((prev) => [...prev, user]);
    onChange(user);
    setIsUserModalOpen(false);
  };

  if (value?.user_id) {
    // Existing admin
    return (
      <>
        <div>
          <a onClick={() => setIsUserModalOpen(true)}>
            {value.first_name} {value.last_name || ''} ({value.username})
          </a>
        </div>
        <Modal
          open={isUserModalOpen}
          footer={null}
          onCancel={() => setIsUserModalOpen(false)}
          destroyOnClose
        >
          <UserForm user={value} isAdmin={true} tenantId={tenantId||null} onSuccess={handleUserCreated} onCancel={() => setIsUserModalOpen(false)} />
        </Modal>
      </>
    );
  }

  return (
    <>
      <Select
        style={{ width: '100%' }}
        placeholder="Select tenant admin"
        loading={loading}
        value={value?.user_id}
        onChange={(id) => {
          const u = users.find((x) => x.user_id === id);
          onChange(u);
        }}
        dropdownRender={(menu) => (
          <>
            {menu}
            <Button
              type="link"
              style={{ width: '100%' }}
              onClick={() => setIsUserModalOpen(true)}
            >
              + Create New User
            </Button>
          </>
        )}
      >
        {users.map((u) => (
          <Select.Option key={u.user_id} value={u.user_id}>
            {u.last_name}, {u.first_name} ({u.email || u.username})
          </Select.Option>
        ))}
      </Select>

      <Modal
        open={isUserModalOpen}
        footer={null}
        onCancel={() => setIsUserModalOpen(false)}
        destroyOnClose
      >
        <UserForm isAdmin={true} persist={false} user={value} tenantId={tenantId||null} onSuccess={handleUserCreated} onCancel={() => setIsUserModalOpen(false)} />
      </Modal>
    </>
  );
};

export default TenantAdminSelector;